import { render, staticRenderFns } from "./SchoolsComponent.vue?vue&type=template&id=35cd48a1&scoped=true"
import script from "./SchoolsComponent.vue?vue&type=script&lang=js"
export * from "./SchoolsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd48a1",
  null
  
)

export default component.exports